<!-- 预赛 -->
<template>
  <div class="page page-pre bg-red">
    <div class="page__inner">
      <div class="sect-wrap">
        <pre-rank-score @change="loadScore" />
      </div>
      <div class="sect-wrap">
        <pre-rank-buy @change="loadBuy" />
      </div>
      <div class="sect-wrap">
        <pre-rank-sell @change="loadSell" />
      </div>
      <div class="sect-wrap">
        <pre-rank-lucky />
      </div>

      <div class="sect-wrap">
        <my-steps />
      </div>
       <ad-vip-audio />
    </div>
  </div>
</template>

<script>
  import {
    mapActions
  } from 'vuex'

  import MySteps from '../my/steps/index'
  import RankScore from './rank-score'
  import RankBuy from './rank-buy'
  import RankSell from './rank-sell'
  import RankLucky from './rank-lucky'

  export default {
    components: {
      [MySteps.name]: MySteps,
      [RankScore.name]: RankScore,
      [RankBuy.name]: RankBuy,
      [RankSell.name]: RankSell,
      [RankLucky.name]: RankLucky
    },
    computed: {
    },
    methods: {
      ...mapActions('match', ['loadPreRank', 'loadWinners']),
      async loadScore(page) {
        return this.loadPreRank({
          type: 1,
          page,
          pageNum: 10
        })
      },
      async loadBuy(page) {
        return this.loadPreRank({
          type: 2,
          page,
          pageNum: 10
        })

      },
      async loadSell(page) {
        return this.loadPreRank({
          type: 3,
          page,
          pageNum: 10
        })
      }
    },
    async created() {
      // TODO: 判断时间是否到了
      await this.loadScore(1)
      await this.loadBuy(1)
      await this.loadSell(1)
      await this.loadWinners()
    }
  };

</script>
